<script setup>
const { data } = defineProps(['data'])

const links = data?.map(({ id, fields }) => {
  let { text, url, icon: iconObj } = fields
  const link = { id, text, url }
  let icon
  if (iconObj) {
    icon = { id: iconObj.sys.id, altText: iconObj.fields.altText }
    iconObj = iconObj.fields.icon.fields
    icon.url = iconObj.file.url
    icon.width = iconObj.file.details.image.width || iconObj.file.details.size
    icon.height = iconObj.file.details.image.height || iconObj.file.details.size
  }
  return { link, icon }
})
</script>

<template>
  <div class="footer__top-section container">
    <IconLinks :data="links" />
  </div>
</template>

<style>
.footer__top-section {
  display: flex;
  justify-content: space-between;
  padding-block: var(--space-60);

  @media (--tablet) {
    padding-block: var(--space-100);
  }
}
</style>
